import SubmitBase from '../base/Submit';
import useFormContext from './useFormContext';


function Submit(props) {
  const { submitting = false, ...restProps } = props;
  const { formState: { isSubmitting } } = useFormContext();
  return <SubmitBase submitting={isSubmitting || submitting} {...restProps} />;
}


Submit.displayName = 'Submit(Generic)';
export default Submit;
